import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import lockerIcon from "../../asset/locker_icon.png"
import cross from "../../asset/cross.png"
import LogoutButton from "./LogoutButton"
import { container } from "../../infrastructure/container"
import { FranchiseService } from "../../infrastructure/services/api/franchise"
import { Logger } from "../../infrastructure/services/logger"
import { SessionService } from "../../infrastructure/services/session"
import { SupportRole } from "../../infrastructure/models/common/supportrole"

const Sidebar: React.FC<{
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}> = ({ isSidebarOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const sessionService = container.resolve<SessionService>("sessionService");
  const user = sessionService.user; // ✅ Get current user

  const sidebarItems = [
    { path: "/dashboard", label: "Franchise Management" },
    { path: "/supportuser", label: "User Management" }
  ];

  return (
    <div
      className={`fixed inset-y-0 left-0 w-64 bg-gray-100 shadow-lg transform transition-transform duration-300 z-50 
      ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 md:relative md:w-64 flex flex-col`}
    >
      {/* Logo Section */}
      <div className="p-4 sm:p-6 flex items-center justify-center bg-blue-700">
        <img src={lockerIcon} alt="Admin Logo" className="w-40 bg-center h-auto bg-white rounded" />
        <button onClick={toggleSidebar} className="md:hidden text-xl">
          <img src={cross} alt="Close Sidebar" className="w-3 h-3" />
        </button>
      </div>

      {/* Sidebar Items */}
      <div className="flex-grow overflow-y-auto bg-blue-700">
        <ul className="mt-3 sm:mt-4">
          {sidebarItems.map((item) => (
            <li
              key={item.path}
              className={`px-4 py-2 mx-0 my-1 sm:my-2 transition-all duration-300 cursor-pointer rounded-l-full 
                ${location.pathname === item.path
                  ? "bg-gray-200 text-blue-700"
                  : "bg-transparent text-white hover:bg-gray-200 hover:text-blue-700 "
                }`}
            >
              <button
                onClick={() => navigate(item.path)}
                className="w-full text-left font-medium"
                aria-label={item.label}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Logout Button */}
      <div className="p-4 bg-blue-700 sticky bottom-0">
        <LogoutButton className="w-full bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-all duration-300" />
      </div>
    </div>
  );
};

export default Sidebar;
